import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./views/Home";
import Confirmation from "./views/Step10_Confirmation";
import TicketDownload from "./views/_Ticket_Download";

// Fallback page
import RegistrationIsClosed from "./views/components/RegistrationIsClosed";
import PageNotFound from "./views/components/PageNotFound";
import InvalidPromocode from "./views/components/InvalidPromocode";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/*<Route path="*" element={<RegistrationIsClosed />} />*/} {/* to close*/}
                {/*<Route path="/:language/home/nachtraeglicheanmeldung/:code" element={<Home />} />*/} {/*to close*/}

                <Route path="*" element={<PageNotFound />} /> {/*to close*/}
                <Route path="/" element={<Navigate to="/de/home/ethtag2026" replace />} /> {/*to close*/}
                <Route path="/:language/home/:code" element={<Home />} /> {/*to close*/}

                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
                <Route path="/:language/invalidpromocode" element={<InvalidPromocode />} />
                <Route path="/:language/download/:orderId/:promocode" element={<TicketDownload />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
